<script setup>
import { useAnalyzer } from '#/analyzer/useAnalyzer'
import FullPopup from '#/general/FullPopup'
import { inject, computed } from 'vue'
const { showMaxNumberOfReportsReached, widgetQuestionnaireForm } = useAnalyzer()
const { pages, application } = inject('Shared')
function sendMail () {
  if (application === 'WEB_APP') {
    window.location.href = 'mailto:andreas@raumpioniere.ch'
  }
}

const computedBody = computed(() => {
  const res = pages.value.map.maxNumberOfReportsReachedPopup.body
  if (application === 'WIDGET') {
    const firstName = widgetQuestionnaireForm.value.fields.firstName.value
    const lastName = widgetQuestionnaireForm.value.fields.lastName.value
    if (res.includes('#{vorname}') || res.includes('#{name}')) {
      return res.replace('#{vorname}', firstName).replace('#{name}', lastName)
    }
  }
  return res
})
</script>

<template lang="pug">
full-popup(
  :fixed="true"
  :persistent="true"
  v-model:visible="showMaxNumberOfReportsReached"
  :btn-label="pages.map.maxNumberOfReportsReachedPopup.btn"
  :title="pages.map.maxNumberOfReportsReachedPopup.title"
  @clicked="sendMail"
)
  div(v-html="computedBody")
</template>

<style lang="sass" scoped>
</style>
